import React from 'react';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import awsConfig from '@config/aws';
import * as constants from '@config/constants';

import { Auth } from 'aws-amplify';

export const constructUrl = threshold_type => {
  const base_url = process.env.REACT_APP_API_BASE_URL;
  const customer_id = process.env.REACT_APP_CUSTOMER_ID;
  const url = `${base_url}screen/console/config/${customer_id}/thresholds`
  //const url =`${base_url}config/${customer_id}/thresholds`
  
  if (threshold_type) {
    return `${url}/${threshold_type}`;
  }
  return url;
};

export const useThresholds = () => {
  const apiKey = useSelector(state => state.keys.key);

  const [errorObj, setErrorObj] = useState(false);
  const [isPendingObj, setIsPendingObj] = useState(false);
  const [dataObj, setDataObj] = useState(null);

  const fetchData = async threshold_type => {
    setErrorObj(false);
    setIsPendingObj(true);

    try {
      const res = await axios.get(constructUrl(threshold_type), {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Content-Type': 'application/json',
          'Authorization': `${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
          'x-api-key': apiKey
        },
      });
      if (!res) {
        throw new errorObj('Could Not Get Thresholds');
      }

      threshold_type
        ? setDataObj(res.data[threshold_type])
        : setDataObj(res.data['null'].account);
      setErrorObj(null);
      setIsPendingObj(false);
    } catch (err) {
      setErrorObj(err.message);
      setIsPendingObj(false);
    }
  };

  return { fetchData, dataObj, isPendingObj, errorObj };
};
